
<section id="testimonials" class="testimonials">
  <h2 class="testimonials__title">{{'landing.testimonials.title'|transloco}}</h2>

  <div class="testimonial">
    <div class="testimonial__picture">
      <img src="assets/images/landing/gael.jpg" alt="Gaël Laniel - Photographe à Paris"/>
    </div>
    <div class="testimonial__content">
      <p class="testimonial__content-text">"{{'landing.testimonials.gael.content' | transloco}}"</p>
      <div>
        <p class="testimonial__content-name">{{'landing.testimonials.gael.name' | transloco}}</p>
        <p class="testimonial__content-job">{{'landing.testimonials.gael.job' | transloco}}</p>
      </div>
      <a class="button"
         [routerLink]="['/photographer', 'gael-laniel']"
      >
        {{'landing.testimonials.gael.cta'|transloco}}
        <i class="fa-solid fa-arrow-right"></i>
      </a>
    </div>
  </div>
</section>
